const hostname = typeof window === 'undefined' ? '' : window.location.hostname

export const isTestEnvironment =
    hostname !== '' && hostname !== 'tipi.ink' && hostname !== 'oktipi.com' && hostname !== 'oidotipi.com'

export const isLocalEnvironment = hostname === 'localhost' || hostname.startsWith('192')
